export enum mailStates {
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  BOUNCED = 'BOUNCED',
  COMPLAINT = 'COMPLAINT',
  OTTO = 'OTTO',
  OPEN = 'OPEN',
  CLICK = 'CLICK',
}
